import { FC, Fragment } from "react";
import { Chip } from "@mui/material";
import { ScheduleActionType2 } from "../../../../../services/cloudchipr.api";

type ChipColorsType = "primary" | "warning" | "error" | "success" | "default";
export type ScheduleStatusStateType =
  | ScheduleActionType2
  | "normal"
  | "paused"
  | "complete"
  | "error"
  | "blocked"
  | "";

const colors: Partial<Record<ScheduleStatusStateType, ChipColorsType>> = {
  active: "success",
  inactive: "warning",
  deleted: "error",
};

interface ScheduleListGridStatusChipProps {
  status: ScheduleStatusStateType;
}
export const SchedulesDataGridStatusChip: FC<
  ScheduleListGridStatusChipProps
> = ({ status }) => {
  if (!status) {
    return <Fragment>-</Fragment>;
  }

  return (
    <Chip
      sx={{ textTransform: "capitalize" }}
      size="small"
      label={status}
      color={colors[status]}
      variant="outlined"
    />
  );
};
